// stores/newPostSharedMediaCacheStore.ts
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface MediaCacheItem {
  id: number
  data: any
}

interface NewPostSharedMediaCacheState {
  mediaMap: Record<string, MediaCacheItem[]>
  setCache: (key: string, media: MediaCacheItem[]) => void
  clear: () => void
}

export const useNewPostSharedMediaCacheStore = create<NewPostSharedMediaCacheState>()(
  persist(
    (set) => ({
      mediaMap: {},
      setCache: (key, media) => set((state) => ({
        mediaMap: {
          ...state.mediaMap,
          [key]: media,
        },
      })),
      clear: () => set({ mediaMap: {} }),
    }),
    {
      name: 'new-post-shared-media-cache', // localStorage key
    }
  )
)
